module.exports = __webpack_public_path__ + "img/004.347a71ed.jpg";